// extracted by mini-css-extract-plugin
export default {"deleteButton":"styles_deleteButton__Rhh22","trashcanIcon":"styles_trashcanIcon__j3+oh"};